import { render, staticRenderFns } from "./TestAdminUI.vue?vue&type=template&id=2d9d749a&scoped=true&"
import script from "./TestAdminUI.vue?vue&type=script&lang=js&"
export * from "./TestAdminUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d749a",
  null
  
)

export default component.exports